export const styles = {
  button: {
    py: 0.75,
    height: '2.25rem',
    minHeight: '2.25rem',
  },
};
